import React from 'react'
import { Link } from "react-router-dom"
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import Img404 from './../images/404.png';
import ImgNotFound from './../images/notFound.png';
import { Helmet } from 'react-helmet-async';


export const Page404 = () => {
  const notFoundStyle = css`
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
    color: #555;
    img {
      width: 20vw;
      height: auto;
    }
    p {
      margin-top: 50px;
    }
  `;
  return (
    <>
      <Helmet>
        <title>🐝｜404 Not Found</title>
      </Helmet>

      <div css={notFoundStyle}>
        <img src={Img404} alt="" />
        <img src={ImgNotFound} alt="" />
        <p>申し訳ございません。<br />指定されたページが見つかりませんでした。</p>

        <Link to="/">Topに戻る</Link>
      </div>
    </>
  )
}
